<template>
    <a-modal v-model="visible" width="900px" title="" :footer="null" centered @cancel="handleCancelEvent" class="modal-box">
        <div class="preview-box mt15">
            <!-- 主题分类 -->
            <p class="flex x-left">
                <span class="color999">{{ $t('submission.abstract_detail.topic_category' /*主题分类*/) }}：</span>
                <span class="color000">{{ info.publish_type }}</span>
            </p>
            <h2 class="mt20 t-c">{{ info.title }}</h2>
            <!-- 作者列表 -->
            <p class="mt30 t-c fs12" v-if="info?.author_list?.length > 0">
                <template v-for="(item, index) in info.author_list">
                    <sup v-if="info.author_list.length > 1">{{ index + 1 }}</sup>
                    <u>{{ item.real_name }}</u>
                </template>
            </p>
            <!-- 单位 地址 邮编 邮箱 -->
            <p style="font-style: italic" class="mt30 t-c fs12" v-for="(item, index) in info.organize_list" :key="index">
                <sup>{{ item.author_nums }}</sup>
                <span>{{ item.org_cnname }}</span>
                <span class="ml10">{{ item.address }}</span>
                <span class="ml10">{{ item.zipcode }}</span>
                <span class="ml10">{{ item.author_emails }}</span>
            </p>
            <!-- 摘要 -->
            <div class="mt20">
                <span class="color999">{{ $t('submission.abstract_detail.abstract' /*摘要*/) }}：</span>
                <div v-for="(item, index) in info.other_infos" :key="index" v-html="item"></div>
            </div>
            <!-- 关键字 -->
            <div class="mt10">
                <span class="color999">{{ $t('submission.abstract_detail.keywords' /*关键字*/) }}：</span>
                <div>
                    {{ info.keywords }}
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
export default {
    name: 'AbstractDetail',
    components: {},
    data() {
        return {
            info: {},
            visible: false
        };
    },
    computed: {},
    methods: {
        show(id) {
            this.visible = true;
            this.$request.post({ url: 'getAbstractListDetail', data: { abstract_id: id, show_author: 1, show_annex: 0 } }).then(res => {
                const { data } = res;
                this.info = data;
            });
        },
        handleCancelEvent() {
            this.visible = false;
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="less" scoped>
.preview-box {
    padding: 30px;
    background-color: #f9f9f9;
}
</style>
